import React from 'react';
import { FaInstagram } from 'react-icons/fa';

const Instagram = () => {
  return (
    <>
      <style>
        {`
          @keyframes pop {
            0% {
              transform: scale(0);
              opacity: 0;
            }
            70% {
              transform: scale(1.2);
              opacity: 1;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
          .animate-pop {
            animation: pop 0.5s ease-out forwards;
          }
        `}
      </style>
      <a
        href="https://www.instagram.com/sonic_tours.srilanka?igsh=c213Mjdob2t6aWQ%3D"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 bg-[#E1306C] text-white p-2 sm:p-3 md:p-4 rounded-full shadow-lg hover:bg-[#C13584] transition-colors duration-300 z-50 animate-pop"
        aria-label="Visit our Instagram page"
      >
        <FaInstagram className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10" />
      </a>
    </>
  );
};

export default Instagram;